import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const CONTENTS = {
  nickname: 'PRODUCTS.CONTENTS.shortname',
  properties: [
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    { name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]] },
    { name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_SUM_INSURED.750', value: 750000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_SUM_INSURED.1500', value: 1500000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_SUM_INSURED.1750', value: 1750000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_SUM_INSURED.2000', value: 2000000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_SUM_INSURED.2500', value: 2500000 },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_SUM_INSURED.3000', value: 3000000 },
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.2', value: '2000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.4', value: '4000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.6', value: '6000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.15', value: '15000' }
        ]
      }
    },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED_CONTENTS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.YES', value: 'true' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.NO', value: 'false' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.PARTIAL', value: 'PARTIAL' },
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
        ]
      }
    },
  ],
  icon:'contents'
};
